import React from 'react';

import TextLayer from '../layers/text_layer';
import FontDefinitionsDialog from './font-definitions-dialog.jsx';

const { $ } = window;

export default class Toolbar2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: props.project,
      showFontDefinitionsDialog: false
    };
  }

  componentDidMount() {
    $('[data-content]').popup();
  }

  mergeCleanLayers() {
    let page = this.state.project.activePage;
    if (!page)
      return;

    page.mergeCleanLayers();
  }

  createTextLayer() {
    let project = this.state.project;
    let page = project.activePage;
    if (!page || !page.selection)
      return;

    let layer = new TextLayer(page, {
      bounds: page.selection,
      fontDefinition: project.currentFontDefinition
    });
    page.addLayer(layer);
    layer.select();
  }

  showFontDefinitionsDialog() {
    this.setState({
      showFontDefinitionsDialog: true
    });
  }

  render() {
    return (
      <div className="ui basic segment">
        <button className="ui icon button" data-content="Объединить слои с клином" onClick={this.mergeCleanLayers.bind(this)}>
          <i className="group object icon" />
        </button>
        <button className="ui icon button" data-content="Создать текстовый слой внутри выделения" onClick={this.createTextLayer.bind(this)}>
          <i className="edit icon" />
        </button>
        <button className="ui right floated icon button" data-content="Пресеты шрифтов" onClick={this.showFontDefinitionsDialog.bind(this)}>
          <i className="font icon" />
        </button>

        <FontDefinitionsDialog toolbar={this} visible={this.state.showFontDefinitionsDialog} />
      </div>
    );
  }
}
